import LoginPage from "beaktShared/views/GenericPages/LoginPage.js";
import UserProfile from "beaktShared/views/GenericPages/UserProfile.js";
import TermoServico from "beaktMatriz/views/Cadastros/TermoServicoList.js";
import GrupoCanalMidiaList from "beaktMatriz/views/Cadastros/GrupoCanalMidiaList.js";
import Home from "beaktMatriz/views/Home.js";
import ProdutoGrupo from "beaktShared/views/Cadastros/ProdutoGruposList.js";
import Produto from "beaktShared/views/Cadastros/ProdutosList.js";
import EspecialidadeList from "beaktShared/views/Cadastros/EspecialidadeList.js";
import ServicoList from "beaktShared/views/Cadastros/ServicoList.js";
import PacoteList from "beaktShared/views/Cadastros/PacoteList.js";
import CredenciamentoList from "beaktMatriz/views/Credenciamento/CredenciamentoList.js";
import GestaoVendas from "beaktMatriz/views/Vendas/GestaoVendas.js";
import GestaoClienteList from "beaktClinic/views/Clientes/GestaoClienteList.js";
import CreditoDebitoList from "beaktMatriz/views/Royalties/CreditoDebitoList.js";
import DebitoFixoList from "beaktMatriz/views/Royalties/DebitoFixoList.js";
import FechamentoRoyalties from "beaktMatriz/views/Royalties/FechamentoRoyalties.js";
import ExtratoRoyalties from "beaktMatriz/views/Royalties/ExtratoRoyalties.js";
import PedidoCompra from "beaktClinic/views/Estoque/PedidoCompra.js";
import GestaoPedidoCompra from "beaktClinic/views/Estoque/GestaoPedidoCompra.js";
import RecebimentoCompra from "beaktMatriz/views/Estoque/RecebimentoCompra.js";
import FornecedorList from "beaktShared/views/Cadastros/FornecedoresList.js";
import ConfirmacaoPagamento from "beaktMatriz/views/Royalties/ConfirmacaoPagamento.js";
import UsuarioList from "beaktShared/views/Seguranca/UsuarioList.js";
import AccessDenied from "beaktShared/views/Seguranca/AcessoNegado.js";
import BoletimOcorrencia from "beaktMatriz/views/Cadastros/BoletimOcorrencia.js";
import RelatorioAnaliticoFechamento from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioAnaliticoFechamento.js";
import RelatorioResumoVendasPorTipoPagamento from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioResumoVendaPorTipoPagamento.js";
import RelatorioCreditosDebitos from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioCreditosDebitos.js";
import RelatorioDividasClinicasFechadas from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioDividasClinicasFechadas.js";
import CredenciamentoRanking from "beaktMatriz/views/Relatorios/RelatoriosSistema/CredenciamentoRanking.js";
import Dashboard from "beaktMatriz/views/Dashboard/Dashboard.js";
import ConciliacaoCartao from "beaktMatriz/views/Royalties/ConciliacaoCartao/ConciliacaoCartao.js";
import ConciliacaoImportarArquivo from "beaktMatriz/views/Royalties/ConciliacaoCartao/ConciliacaoImportarArquivo.js";
import ConciliacaoLancamentoManual from "beaktMatriz/views/Royalties/ConciliacaoCartao/ConciliacaoLancamentoManual.js";
import ConciliacaoPendente from "beaktMatriz/views/Royalties/ConciliacaoCartao/ConciliacaoPendente.js";
import RelatorioPagamentosUra from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioPagamentosUra.js";
import RelatorioVendabyPacotes from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioVendabyPacotes.js";
import RelatorioVendabyServicos from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioVendabyServicos.js";
import RelatorioVendabyProdutos from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioVendabyProdutos.js";
import RelatorioLogFechamento from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioLogFechamento.js";
import ControleFinanceiro from "beaktClinic/views/Financeiro/ControleFinanceiro.js";
import RelatorioDetalhamentoContrato from "beaktClinic/views/Relatorios/RelatoriosSistema/RelatorioDetalhamentoContrato.js";
import RelatorioBoletimOcorrencia from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioBoletimOcorrencia.js";
import RelatorioRankingFaturamento from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioRankingFaturamento.js";
import RelatorioTicketMedio from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioTicketMedio.js";
import ClausulaContratoList from "beaktMatriz/views/Cadastros/ClausulaContratoList.js";
import RelatorioMidiaxVendas from "beaktClinic/views/Relatorios/RelatoriosSistema/RelatorioMidiaxVendas.js";
import AlteracaoVendaList from "beaktMatriz/views/Vendas/AlteracaoVendaList.js";
import RelatoriosPersonalizadosList from "beaktMatriz/views/Relatorios/RelatoriosPersonalizadosList.js";
import RelatoriosSistemaList from "beaktMatriz/views/Relatorios/RelatoriosSistemaList.js";
import ExtratoRoyaltiesDM2 from "./views/Royalties/ExtratoRoyaltiesDM2";
import GestaoAgenda from "beaktDay/views/AdminAgenda/Agenda/GestaoAgenda.js";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Settings from "@material-ui/icons/Settings";
import Book from "@material-ui/icons/Book";
import HomeIcon from "@material-ui/icons/Home";
import CalendarViewDay from "@material-ui/icons/CalendarViewDay";
import People from "@material-ui/icons/People";
import Money from "@material-ui/icons/Money";
import WidgetsIcon from '@material-ui/icons/Widgets';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import Description from '@material-ui/icons/Description';
import BarChart from "@material-ui/icons/BarChart";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Edit from '@material-ui/icons/Edit';
import CalendarToday from "@material-ui/icons/CalendarToday";


var Routes = [
  {
    path: "/login",
    name: "login",
    mini: "L",
    component: LoginPage,
    layout: "/auth",
    showmenu: false
  },
  {
    path: "/user",
    name: "profile",
    mini: "MP",
    icon: Face,
    component: UserProfile,
    layout: "/adminmatriz",
    showmenu: false
  },  
  {
    path: "/home",
    name: "home",
    mini: "H",
    icon: HomeIcon,
    component: Home,
    layout: "/adminmatriz",
    showmenu: true
  }, 
  {
    path: "/dashboard",
    name: "dashboard",
    mini: "H",
    icon: BarChart,
    component: Dashboard,
    layout: "/adminmatriz",
    showmenu: true
  },
  {
    collapse: true,
    name: "accreditation",
    icon: Book,
    state: "credenciamentoCollapse",
    views: [
      {        
        path: "/credenciamento",
        name: "accreditation_management",
        mini: "GC",
        component: CredenciamentoList,
        layout: "/adminmatriz",
        showmenu: true
      }
    ]
  },
  {
    collapse: true,
    name: "sales",
    icon: ReceiptIcon,
    state: "salesCollapse",
    views: [
      {
        path: "/gestaovendas",
        name: "sales_management",
        mini: "GA",
        icon: CalendarViewDay,
        component: GestaoVendas,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/alteracaovendalist",
        name: "sale_change",
        mini: "GA",
        icon: Edit,
        component: AlteracaoVendaList,
        layout: "/adminmatriz",
        showmenu: true
      },
    ]
  },
  {
    collapse: true,
    name: "agenda",
    icon: CalendarToday,
    state: "agendaCollapse",
    views: [
      {
        path: "/gestaoagenda",
        name: "agenda_management",
        mini: "GA",
        component: GestaoAgenda,
        layout: "/adminMatriz",
        showmenu: true
      }
    ]
  }, 
  {
    path: "/gestaoclientes",
    name: "clients",
    icon: People,
    component: GestaoClienteList,
    layout: "/adminmatriz",
    showmenu: true
  },
  {
    collapse: true,
    name: "stock",
    icon: WidgetsIcon,
    state: "estoqueCollapse",
    views: [
      {
        path: "/pedidocompra",
        name: "purchase_order",
        mini: "PC",
        component: PedidoCompra,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/gestaopedidocompra",
        name: "order_management",
        mini: "GP",
        component: GestaoPedidoCompra,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/recebimentocompra",
        name: "purchase_receipt",
        mini: "RC",
        component: RecebimentoCompra,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/cadastrofornecedor",
        name: "supplier_register",
        mini: "CF",
        component: FornecedorList,
        layout: "/adminmatriz",
        showmenu: true
      },
    ]
  },
  {
    collapse: true,
    name: "royalties",
    icon: Money,
    state: "royaltiesCollapse",
    views: [
      {
        path: "/creditodebitos",
        name: "credits_and_debits",
        mini: "CD",
        component: CreditoDebitoList,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/debitofixos",
        name: "fixed_debits",
        mini: "DF",
        component: DebitoFixoList,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/conciliacaocartao",
        name: "card_reconciliation",
        mini: "CC",
        component: ConciliacaoCartao,
        layout: "/adminmatriz",
        showmenu: true
      },      
      {
        path: "/fechamentoroyalties",
        name: "royalties_closing",
        mini: "FR",
        component: FechamentoRoyalties,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/extratoroyalties",
        name: "royalties_extract",
        mini: "ER",
        component: ExtratoRoyalties,
        layout: "/adminmatriz",
        showmenu: false,
        pathFather: "/fechamentoroyalties"
      },
      {
        path: "/extratoroyaltiesdm2",
        name: "royalties_extract_dm2",
        mini: "E2",
        component: ExtratoRoyaltiesDM2,
        layout: "/adminmatriz",
        showmenu: false,
        pathFather: "/fechamentoroyalties"
      },
      {
        path: "/confirmacaopagamento",
        name: "payment_confirmation",
        mini: "CP",
        component: ConfirmacaoPagamento,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/conciliacaoImportararquivo",
        name: "import_file",
        mini: "CC",
        component: ConciliacaoImportarArquivo,
        layout: "/adminmatriz",
        showmenu: false,
        pathFather: "/conciliacaocartao",
      },
      {
        path: "/conciliacaoLancamentoManual",
        name: "manual_post_reconciliation",
        mini: "CC",
        component: ConciliacaoLancamentoManual,
        layout: "/adminmatriz",
        showmenu: false,
        pathFather: "/conciliacaocartao",
      },
      {
        path: "/conciliacaoPendente",
        name: "pending_reconciliation",
        mini: "CC",
        component: ConciliacaoPendente,
        layout: "/adminmatriz",
        showmenu: false,        
        pathFather: "/conciliacaocartao",
      }
    ]
  },
  {
    collapse: true,
    name: "reporting",
    icon: Description,
    state: "relatoriosCollapse",
    views: 
    [
      {
          path: "/relPersonalizados",
          name: "custom_reports",
          mini: "RP",        
          component: RelatoriosPersonalizadosList,
          layout: "/adminmatriz",
          showmenu: true
      },
      {
        path: "/relSistema",
        name: "system_reports",   
        mini: "RS",     
        component: RelatoriosSistemaList,
        layout: "/adminmatriz",
        showmenu: true
      }  
    ]
  },
  {
    collapse: true,
    name: "settings",
    icon: Settings,
    state: "configCollapse",
    views: [
      {
        path: "/cadastrogruposproduto",
        name: "product_group_register",
        mini: "GP",
        component: ProdutoGrupo,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/cadastroproduto",
        name: "product_register",
        mini: "P",
        component: Produto,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/cadastroespecialidade",
        name: "specialty_register",
        mini: "CE",
        component: EspecialidadeList,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/cadastroservico",
        name: "service_register",
        mini: "CS",
        component: ServicoList,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/cadastropacote",
        name: "package_register",
        mini: "CP",
        component: PacoteList,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/clausulacontratoList",
        name: "clauses_register",
        mini: "RC",
        component: ClausulaContratoList,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/cadastrotermos",
        name: "terms_register",
        mini: "TS",
        component: TermoServico,
        layout: "/adminmatriz",
        showmenu: true
      },
      {
        path: "/cadastrogrupocanalmidia",
        name: "media_channel_group",
        mini: "CM",
        component: GrupoCanalMidiaList,
        layout: "/adminmatriz",
        showmenu: true
      }
    ]
  }, 
  {
    path: "/boletimocorrencia",
    name: "report_of_occurrence",
    icon: PlaylistAddCheckIcon,
    component: BoletimOcorrencia,
    layout: "/adminmatriz",
    showmenu: true
  },
  {
    path: "/usuarios",
    name: "safety",
    icon: VerifiedUserIcon,
    component: UsuarioList,
    layout: "/adminmatriz",
    showmenu: true
  },
  {
    path: "/controlefinanceiro",
    name: "financial",
    icon: LocalAtmIcon,
    component: ControleFinanceiro,
    layout: "/adminmatriz",
    showmenu: true
  },
  {
    path: "/accessdenied",
    name: "",
    icon: VerifiedUserIcon,
    component: AccessDenied,
    layout: "/adminmatriz",
    showmenu: false
  },  
];
export default Routes;
